import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AssessmentCompletionTemplate from '../components/AssessmentCompletionTemplate';
import { createAssessmentConfig } from '../config/assessmentCompletionConfigs';

interface ReligioTraditioCulturalAssessmentResult {
  id: string;
  assessmentType: string;
  scores: {
    overall: number;
    category1: number; // Brief RCOPE
    category2: number; // CVSCALE
    category3: number; // TVAS
  };
  results: {
    level: 'Low' | 'Moderate' | 'High';
    interpretation: string;
    recommendations: string[];
  };
  createdAt: string;
}

const ReligioTraditioCulturalAssessmentCompletionPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const assessmentResult = location.state?.assessmentResult as ReligioTraditioCulturalAssessmentResult;
  
  if (!assessmentResult || !assessmentResult.scores || !assessmentResult.results) {

    navigate('/panel/learn/');
    return null;
  }

  try {
    const isBriefRCOPE = assessmentResult.scores.category1 > 0 && assessmentResult.scores.category2 === 0 && assessmentResult.scores.category3 === 0;
    const isCVSCALE = assessmentResult.scores.category2 > 0 && assessmentResult.scores.category1 === 0 && assessmentResult.scores.category3 === 0;
    const isTVAS = assessmentResult.scores.category3 > 0 && assessmentResult.scores.category1 === 0 && assessmentResult.scores.category2 === 0;
    
    const scoreLabel = isBriefRCOPE ? 'Brief RCOPE Score' : isCVSCALE ? 'CVSCALE Score' : isTVAS ? 'TVAS Score' : 'Assessment Score';
    const assessmentName = isBriefRCOPE ? 'Brief RCOPE Assessment' : isCVSCALE ? 'CVSCALE Assessment' : isTVAS ? 'TVAS Assessment' : 'Religio-Traditio-Cultural Assessment';
    
    const config = createAssessmentConfig(assessmentResult, {
      assessmentType: 'religio-traditio-cultural',
      assessmentName: 'religio-traditio-cultural-assessment',
      assessmentDisplayName: assessmentName.toUpperCase(),
      redoRoute: '/panel/learn/religio-traditio-cultural-assessment',
      completeRoute: '/panel/insights',
      scoreLabel: scoreLabel,
      subtitleMapping: {
        High: isBriefRCOPE ? 'High Religious Coping' : isCVSCALE ? 'Strong Cultural Values' : isTVAS ? 'Strong Traditional Values' : 'High Score',
        Moderate: isBriefRCOPE ? 'Moderate Religious Coping' : isCVSCALE ? 'Moderate Cultural Values' : isTVAS ? 'Moderate Traditional Values' : 'Moderate Score',
        Low: isBriefRCOPE ? 'Low Religious Coping' : isCVSCALE ? 'Low Cultural Values' : isTVAS ? 'Low Traditional Values' : 'Low Score'
      },
      visualMessage: "You've completed the assessment!",
      resultsTitle: isBriefRCOPE ? "Here's your religious coping analysis" : isCVSCALE ? "Here's your cultural values analysis" : isTVAS ? "Here's your traditional values analysis" : "Here's your assessment analysis"
    });
    
    return <AssessmentCompletionTemplate config={config} />;
  } catch (error) {

    navigate('/panel/learn/');
    return null;
  }
};

export default ReligioTraditioCulturalAssessmentCompletionPage;



